import React, { cloneElement } from 'react';
import { motion } from 'framer-motion';
import { Heart, Shield, Star, Award, Users, Clock } from 'lucide-react';
export function AboutSection() {
  return <section id="about" className="py-24 bg-white relative overflow-hidden" data-id="element-4">
      <div className="container mx-auto px-6" data-id="element-5">
        <div className="grid lg:grid-cols-2 gap-20 items-center" data-id="element-6">
          {/* Image Side */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="relative" data-id="element-7">
            <div className="relative z-10 rounded-[40px] overflow-hidden shadow-2xl" data-id="element-8">
              <img src="https://www.harmonyhealthcaremd.com/wp-content/themes/harmonyhealthcarees376/images/btm2-box2-img.webp" alt="Caregiver with Client" className="w-full h-[600px] object-cover" data-id="element-9" />
              <div className="absolute inset-0 bg-gradient-to-t from-primary/20 to-transparent" data-id="element-10" />
            </div>

            {/* Floating Stats */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.8
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.3
          }} className="absolute -bottom-10 -right-10 z-20 p-8 bg-white rounded-3xl shadow-2xl border border-gray-100 max-w-[280px]" data-id="element-11">
              <div className="flex items-center gap-4 mb-4" data-id="element-12">
                <div className="w-12 h-12 bg-primary/10 rounded-2xl flex items-center justify-center text-primary" data-id="element-13">
                  <Star className="w-6 h-6 fill-current" data-id="element-14" />
                </div>
                <div data-id="element-15">
                  <div className="text-2xl font-bold text-dark-text" data-id="element-16">4.9/5</div>
                  <div className="text-xs text-body-text font-medium uppercase tracking-wider" data-id="element-17">
                    Family Rating
                  </div>
                </div>
              </div>
              <p className="text-sm text-body-text leading-relaxed" data-id="element-18">
                Trusted by hundreds of families across Maryland for our
                excellence in care.
              </p>
            </motion.div>

            {/* Decorative Shapes */}
            <div className="absolute -top-10 -left-10 w-40 h-40 bg-secondary/10 rounded-full blur-3xl -z-10" data-id="element-19" />
            <div className="absolute top-1/2 -right-20 w-60 h-60 bg-primary/5 rounded-full blur-[80px] -z-10" data-id="element-20" />
          </motion.div>

          {/* Content Side */}
          <motion.div initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-21">
            <span className="text-primary font-bold tracking-widest uppercase text-sm mb-4 block" data-id="element-22">
              About Harmony Healthcare
            </span>
            <h2 className="text-4xl lg:text-5xl font-heading font-bold text-dark-text mb-8 leading-tight" data-id="element-23">
              Begin Living a{' '}
              <span className="text-secondary" data-id="element-24">Wholesome Life</span> at Home
            </h2>
            <p className="text-lg text-body-text mb-8 leading-relaxed" data-id="element-25">
              Harmony Healthcare, INC is a premier home healthcare provider
              dedicated to delivering world-class medical and personal care
              services. We believe that healing and comfort are best achieved in
              the familiar surroundings of home.
            </p>

            <div className="grid sm:grid-cols-2 gap-8 mb-10" data-id="element-26">
              {[{
              icon: <Heart data-id="element-27" />,
              title: 'Compassion First',
              desc: 'We treat every client like our own family.'
            }, {
              icon: <Shield data-id="element-28" />,
              title: 'Safety & Trust',
              desc: 'Rigorous screening and licensed professionals.'
            }, {
              icon: <Award data-id="element-29" />,
              title: 'Excellence',
              desc: 'Committed to the highest clinical standards.'
            }, {
              icon: <Users data-id="element-30" />,
              title: 'Family Centered',
              desc: 'Keeping loved ones informed and involved.'
            }].map((item, i) => <div key={i} className="flex gap-4" data-id="element-31">
                  <div className="flex-shrink-0 w-10 h-10 bg-accent rounded-xl flex items-center justify-center text-primary" data-id="element-32">
                    {cloneElement(item.icon as React.ReactElement, {
                  className: 'w-5 h-5'
                })}
                  </div>
                  <div data-id="element-33">
                    <h4 className="font-bold text-dark-text mb-1" data-id="element-34">
                      {item.title}
                    </h4>
                    <p className="text-sm text-body-text leading-relaxed" data-id="element-35">
                      {item.desc}
                    </p>
                  </div>
                </div>)}
            </div>

            <button className="px-8 py-4 bg-dark-text text-white font-bold rounded-full hover:bg-black transition-all duration-300 shadow-lg hover:-translate-y-1" data-id="element-36">
              Learn More About Us
            </button>
          </motion.div>
        </div>
      </div>
    </section>;
}